<template>
	<DjBox class="pt-5 md:pt-8 px-5 md:px-10 pb-5 md:pb-10">
		<h3 class="text-lg md:text-xl font-medium mb-4">{{ title }}</h3>
		<div class="flex flex-col">
			<template v-if="data && data.type == 'flexibe'">
				<span class="font-medium">{{ langs.flexible[locale] }}</span>
				<div class="h-[1px] w-full bg-dj-gray-light mt-4 mb-5"></div>
			</template>
			<span class="text-sm mb-2">{{ langs.weeklyWorkingHours[locale] }}</span>
			<span v-if="data" class="font-medium">
				{{ data.weekly_hours }}
				{{ isNaN(Number.parseInt(data.weekly_hours!)) ? "" : langs.hoursPerWeek[locale] }}
			</span>
			<template v-if="data && data.to != undefined && !isNaN(Number.parseInt(data.to))">
				<div class="h-[1px] w-full bg-dj-gray-light mt-4 mb-5"></div>
				<span class="text-sm mb-2">{{ langs.coreTime[locale] }}</span>
				<span class="font-medium">{{ data.from }} - {{ data.to }}</span>
			</template>
		</div>
	</DjBox>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

type TData = {
	type: string;
	to?: string;
	from?: string;
	weekly_hours?: string;
};

export default defineComponent({
	name: "DjBoxWorkSchedule",
	props: {
		title: {
			type: String,
			default: "title",
		},
		data: {
			type: Object as PropType<TData>,
			required: false,
		},
		langs: {
			type: Object,
			required: true,
		},
		locale: {
			type: String,
			default: "hu",
		},
	},
});
</script>
